<template>
    <div :class="className" :style="{height:eHeight,width:width}" />
</template>
<script>
import * as echarts from 'echarts'
require('echarts/theme/macarons') // echarts theme
import resize from './mixins/resize'


export default {
    mixins: [resize],
    props: {
        className: {
            type: String,
            default: 'chart'
        },
        width: {
            type: String,
            default: '100%'
        },
        eHeight: {
            type: String,
            default: '100%'
        },
        autoResize: {
            type: Boolean,
            default: true
        },
        chartData: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            chart: null
        }
    },
    watch: {
        chartData: {
            deep: true,
            handler(val) {
                this.setOptions(val)
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.initChart()
        })
    },
    beforeDestroy() {
        if (!this.chart) {
            return
        }
        this.chart.dispose()
        this.chart = null
    },
    methods: {
        initChart() {
            this.chart = echarts.init(this.$el, 'macarons')
            this.setOptions(this.chartData || {})
        },
        setOptions(data) {
            let arr = ['#ff0000', '#409eff', '#107d28', '#b59e2c', '#b31fcd', '#66b5a6', '#f56c6c', '#5fa215']
            this.chart.setOption({
                grid: {
                    left: '10%',
                    right: '10%'
                },
                tooltip: {
                  backgroundColor:'rgba(255,255,255,1)'
                },
                xAxis: {
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    splitArea: {
                        show: false
                    },
                    splitLine: {
                        show: false
                    }
                },
                yAxis: {
                    type: 'value',

                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    splitArea: {
                        show: false
                    },
                    splitLine: {
                        show: false
                    }
                },
                series: [{
                    // symbol: 'none',
                    symbolSize: 0,
                    type: 'scatter',
                    itemStyle: {
                        normal: {
                            label: {
                                // position: ['-50%', '-50%'],
                                show: true,
                                color: '#000',
                                formatter: function(parma) {
                                    return parma.value[2]
                                }
                            }
                        }
                    },
                    data: [{
                            value: [Math.floor(Math.random() * 10), Math.floor(Math.random() * 10), '政策救助'],

                            label: {
                                color: arr[Math.floor(Math.random() * arr.length)],
                                fontSize: Math.floor(Math.random() * 10 + 12)
                            },
                        },
                        {
                            value: [Math.floor(Math.random() * 10), Math.floor(Math.random() * 10), '思政教导'],
                            label: {
                                color: arr[Math.floor(Math.random() * arr.length)],
                                fontSize: Math.floor(Math.random() * 10 + 12)
                            },
                        },
                        {
                            value: [Math.floor(Math.random() * 10), Math.floor(Math.random() * 10), '综合援助'],
                            label: {
                                color: arr[Math.floor(Math.random() * arr.length)],
                                fontSize: Math.floor(Math.random() * 10 + 12)
                            },
                        },
                        {
                            value: [Math.floor(Math.random() * 10), Math.floor(Math.random() * 10), '心理援助'],
                            label: {
                                color: arr[Math.floor(Math.random() * arr.length)],
                                fontSize: Math.floor(Math.random() * 10 + 12)
                            },
                        },
                        {
                            value: [Math.floor(Math.random() * 10), Math.floor(Math.random() * 50), '社会调查'],
                            label: {
                                color: arr[Math.floor(Math.random() * arr.length)],
                                fontSize: Math.floor(Math.random() * 10 + 12)
                            },
                        }, {
                            value: [Math.floor(Math.random() * 10), Math.floor(Math.random() * 0), '督促监护令'],
                            label: {
                                color: arr[Math.floor(Math.random() * arr.length)],
                                fontSize: Math.floor(Math.random() * 10 + 12)
                            },
                        }, {
                            value: [Math.floor(Math.random() * 10), Math.floor(Math.random() * 1), '附条件不起诉'],
                            label: {
                                color: arr[Math.floor(Math.random() * arr.length)],
                                fontSize: Math.floor(Math.random() * 10 + 12)
                            },
                        }, {
                            value: [Math.floor(Math.random() * 10), Math.floor(Math.random() * 10), '社会救助'],
                            label: {
                                color: arr[Math.floor(Math.random() * arr.length)],
                                fontSize: Math.floor(Math.random() * 10 + 12)
                            },
                        },
                        {
                            value: [Math.floor(Math.random() * 10), Math.floor(Math.random() * 10), '社会救助'],
                            label: {
                                color: arr[Math.floor(Math.random() * arr.length)],
                                fontSize: Math.floor(Math.random() * 10 + 12)
                            },
                        },
                        {
                            value: [Math.floor(Math.random() * 10), Math.floor(Math.random() * 10), '心理援助'],
                            label: {
                                color: arr[Math.floor(Math.random() * arr.length)],
                                fontSize: Math.floor(Math.random() * 10 + 12)
                            },
                        },
                        {
                            value: [Math.floor(Math.random() * 10), Math.floor(Math.random() * 10), '心理援助'],
                            label: {
                                color: arr[Math.floor(Math.random() * arr.length)],
                                fontSize: Math.floor(Math.random() * 10 + 12)
                            },
                        }, {
                            value: [Math.floor(Math.random() * 10), Math.floor(Math.random() * 10), '心理援助'],
                            label: {
                                color: arr[Math.floor(Math.random() * arr.length)],
                                fontSize: Math.floor(Math.random() * 10 + 12)
                            },
                        }, {
                            value: [Math.floor(Math.random() * 10), Math.floor(Math.random() * 10), '心理援助'],
                            label: {
                                color: arr[Math.floor(Math.random() * arr.length)],
                                fontSize: Math.floor(Math.random() * 10 + 12)
                            },
                        }, {
                            value: [Math.floor(Math.random() * 10), Math.floor(Math.random() * 10), '心理援助'],
                            label: {
                                color: arr[Math.floor(Math.random() * arr.length)],
                                fontSize: Math.floor(Math.random() * 10 + 12)
                            },
                        },
                        {
                            value: [Math.floor(Math.random() * 10), Math.floor(Math.random() * 10), '心理援助'],
                            label: {
                                color: arr[Math.floor(Math.random() * arr.length)],
                                fontSize: Math.floor(Math.random() * 10 + 12)
                            },
                        },
                        {
                            value: [Math.floor(Math.random() * 10), Math.floor(Math.random() * 10), '思政教导'],
                            label: {
                                color: arr[Math.floor(Math.random() * arr.length)],
                                fontSize: Math.floor(Math.random() * 10 + 12)
                            },
                        },
                        {
                            value: [Math.floor(Math.random() * 10), Math.floor(Math.random() * 10), '思政教导'],
                            label: {
                                color: arr[Math.floor(Math.random() * arr.length)],
                                fontSize: Math.floor(Math.random() * 10 + 12)
                            },
                        }, {
                            value: [Math.floor(Math.random() * 10), Math.floor(Math.random() * 53), '附条件不起诉'],
                            label: {
                                color: arr[Math.floor(Math.random() * arr.length)],
                                fontSize: Math.floor(Math.random() * 10 + 12)
                            },
                        }, {
                            value: [Math.floor(Math.random() * 10), Math.floor(Math.random() * 10), '社会救助'],
                            label: {
                                color: arr[Math.floor(Math.random() * arr.length)],
                                fontSize: Math.floor(Math.random() * 10 + 12)
                            },
                        }
                    ]
                }]
            })
        }
    }
}

</script>
